var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpinion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 25,
  viewBox: "0 0 26 25",
  fill: "#34B8B5",
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v20.161H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 25l3.545-7.258h-7.09z"
})));
export default SvgOpinion;